import {callApi} from './serviceUtil.js'


export const fetchFoirData = async (data) => {
    const url = data.url;
    const headers = {
        
    }
    const body = "";
    return await callApi({
        url: url,
        method: 'GET',
        headers : headers,
        body : body,
        auth : true
      });
};

export const updateFoirAccountObligation = async (data) => {
    const url = data.url;
    const headers = {
        "Content-Type": "application/json",
    }
    const body = JSON.stringify(data.post_data);
    return await callApi({
        url: url,
        method: 'POST',
        headers : headers,
        body : body,
        auth : true
      });
};



export const fetchRestructureDetails = async (data) => {
    const url = data.url;
    const headers = {
        
    }
    const body = "";
    return await callApi({
        url: url,
        method: 'GET',
        headers : headers,
        body : body,
        auth : true
      });
};

export const fetchCreditDetails = async (data) => {
    const url = data.url;
    const headers = {
        
    }
    const body = "";
    return await callApi({
        url: url,
        method: 'GET',
        headers : headers,
        body : body,
        auth : true
      });
};


export const updateLoanStatus = async (data) => {
    const url = data.url;
    const headers = {
        "Content-Type": "application/json",
    }
    const body = JSON.stringify(data.post_data);
    return await callApi({
        url: url,
        method: 'POST',
        headers : headers,
        body : body,
        auth : true
      });
};

export const calculateEmi = async (data) => {
    const url = data.url;
    const headers = {
        "Content-Type": "application/json",
    }
    const body = JSON.stringify(data.post_data);
    return await callApi({
        url: url,
        method: 'POST',
        headers : headers,
        body : body,
       // auth : true
      });
};


export const getCreditComments = async (data) => {
    const url = data.url;
    const headers = {
        
    }
    const body = "";
    return await callApi({
        url: url,
        method: 'GET',
        headers : headers,
        body : body,
        auth : true
      });
};